var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"popup"},[(!_vm.renderContents)?_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_c('popup-data',{attrs:{"feature":_vm.feature,"render-contents":_vm.renderContents,"table-fallback":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }